<template>
  <div class="creatAccount">
    <set-information v-show="pages == 1" ref="SetInformation"></set-information>
    <Distribution v-show="pages == 2" ref="Distribution"></Distribution>
    <sure-information
      v-show="pages == 3"
      :SetInformation="SetInformation"
      :Distribution="Distribution"
      ref="SureInformation"
    ></sure-information>
    <div class="fixed-bottom-btnList">
      <el-button class="fixed-bottom-btn" type="primary" @click="goBack">{{
        pages > 1 ? $t('setAccount.creatAccount.toPrev') : $t('setAccount.creatAccount.goBack')
      }}</el-button>
      <el-button class="pageNext"
        >{{ $t('setAccount.creatAccount.pageNext') }}{{ pages }}/{{
          $t('setAccount.creatAccount.pageNumber')
        }}</el-button
      >
      <el-button type="primary" class="fixed-bottom-btn" @click="toNext">{{
        $t('setAccount.creatAccount.toNext')
      }}</el-button>
    </div>
  </div>
</template>
<script>
  import API from '@/api/systemManage/accountManage';
  import { mapState } from 'vuex';
  import SetInformation from './components/setInformation';
  import Distribution from './components/distribution';
  import SureInformation from './components/sureInformation';
  export default {
    name: 'creatAccount',
    components: {
      SetInformation,
      Distribution,
      SureInformation,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    data() {
      return {
        pages: 1,
        activeNames: ['1', '2'], //默认展开那些面板，
        SetInformation: [], //第一步表格信息
        Distribution: [], //第二步表格信息
        LegalList: [], //法人主体
      };
    },
    mounted() {
      this.getLegal();
    },
    methods: {
      //返回上一步
      goBack() {
        if (this.pages > 1) {
          this.pages = this.pages - 1;
        } else {
          this.toRouter();
        }
      },
      //下一步
      toNext() {
        if (this.pages == 1) {
          Promise.resolve(this.$refs.SetInformation.fullValidEvent()).then((r) => {
            if (r) {
              this.SetInformation = this.$refs.SetInformation.setInformationData;
              let ledgerCodeFlag = false;
              let ledgerNameFlag = false;
              this.$axios.post(API.GET_LIST_LEDGERS).then((res) => {
                ledgerCodeFlag = res.data.data.records.some((item) => {
                  return this.SetInformation[0].ledgerCode == item.ledgerCode;
                });
                ledgerNameFlag = res.data.data.records.some((item) => {
                  return this.SetInformation[0].ledgerName == item.ledgerName;
                });
                if (ledgerCodeFlag) {
                  this.$message({
                    showClose: true,
                    message: this.$t('setAccount.accountList.ledgerCodeFlagHad'),
                    type: 'error',
                  });
                } else if (ledgerNameFlag) {
                  this.$message({
                    showClose: true,
                    message: this.$t('setAccount.accountList.ledgerNameFlagHad'),
                    type: 'error',
                  });
                } else {
                  this.pages = this.pages + 1;
                }
              });
            }
          });
        } else if (this.pages == 2) {
          Promise.resolve(this.$refs.Distribution.fullValidEvent()).then((r) => {
            if (r) {
              let flag = false;
              this.Distribution = this.$refs.Distribution.distriButionData;
              let arr = this.Distribution.map((i) => i.legalEntityCode);
              if (new Set(arr).size !== arr.length) {
                flag = true;
              }
              if (!flag) {
                //法人主体查重
                let choseFlag = false;
                arr.forEach((item) => {
                  this.LegalList.forEach((r) => {
                    if (item == r.legalEntityCode) {
                      choseFlag = true;
                    }
                  });
                });
                if (choseFlag) {
                  this.$message({
                    showClose: true,
                    message: this.$t('setAccount.accountList.choseFlagHad'),
                    type: 'error',
                  });
                } else {
                  this.pages = this.pages + 1;
                }
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('setAccount.creatAccount.legalEntity'),
                  type: 'error',
                });
              }
            }
          });
        } else if (this.pages == 3) {
          //提交接口
          this.$confirmAction(
            this.$t('setAccount.creatAccount.action'),
            this.$t('setAccount.creatAccount.actionTitle')
          )
            .then(() => {
              let params = Object.assign({}, this.userInfo.userInfo, this.SetInformation[0]);
              params.ledgerLegalEntity = this.Distribution;
              this.$axios.post(API.ADD_LEDGER, params).then((res) => {
                if (res.data.code == 0) {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                  });
                  this.toRouter();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: this.$t('setAccount.creatAccount.saveCancelled'),
              });
            });
        }
      },
      //跳转路由
      toRouter() {
        let path = {
          fromPath: {
            path: '/system/creatAccount',
            name: 'creatAccount',
            meta: {
              keepAlive: true,
              title: this.$t('setAccount.accountList.creatAccount'),
            },
          },
          toPath: {
            path: '/system/AccountList',
            name: 'AccountList',
            meta: {
              keepAlive: true,
              title: this.$t('setAccount.creatAccount.selectAccount'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //获取已分配账套法人主体
      getLegal() {
        this.$axios.get(API.LIST_ALL_LEDGER_LEGAL_ENTITY).then((res) => {
          if (res.data.code == 0) {
            this.LegalList = res.data.data;
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .creatAccount .pageNext {
    border: none;
    //   margin-left: 0;
    padding: 0px;
    background: none;
    color: black;
  }
</style>
